import gql from 'graphql-tag';

export const HOME_SUPPORT_FOR_YOU_QUERY = gql`
  query HomeSupportForYou {
    user {
      id
      features
    }
  }
`;
